module.exports = __webpack_public_path__ + "static/media/ChromiumDoorAnimation.a3a1cd0c.mp4";